import styled, { css } from 'styled-components';

export enum ModalSize { SMALL, MEDIUM, BIG }

export interface ModalParams {
    size: ModalSize;
    content: JSX.Element;
    naked?: boolean;
}

export default function ModalBody({ size, content, naked = false, ...rest }: ModalParams) {
    return (
        <Wrapper size={size} naked={naked}>{content}</Wrapper>
    )
}

const Wrapper = styled.div<{ size: ModalParams['size'], naked: boolean }>`
    background-color: ${props => props.theme.foregroundColor};
    border-radius: ${props => props.theme.borderRadius};
    max-width: 90vw;

    ${({ size }) => sizes[size]}

    ${({ naked }) => naked && css`background-color: unset; padding: unset;`}
`

const sizes = {
    [ModalSize.SMALL]: css`
        padding: 10px;
        width: 400px;
    `,
    [ModalSize.MEDIUM]: css`
        padding: 10px;
        width: 600px;
    `,
    [ModalSize.BIG]: css`
        padding: 20px;
        width: 1200px;
    `,
}